import userApi from './index'
import resourceApi from './resource'
// import inquiryApi from './inquiry'
class WholeApi {
	constructor(env) {
		this.env = env
	}
  
	factoryApi() {
		if (this.env === 'user') return new userApi('user')
		if (this.env === 'oauth') return new userApi('oauth')
		if (this.env === 'resource') return new resourceApi('resource')
		if (this.env === 'inquiry') return new inquiryApi('inquiry')
	}
}

export default WholeApi